/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrganizationGroupSearchOrderBy {
    Name = 'Name',
    ShortName = 'ShortName',
    Description = 'Description'
}


export function instanceOfOrganizationGroupSearchOrderBy(value: any): boolean {
    for (const key in OrganizationGroupSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(OrganizationGroupSearchOrderBy, key)) {
            if (OrganizationGroupSearchOrderBy[key as keyof typeof OrganizationGroupSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrganizationGroupSearchOrderByFromJSON(json: any): OrganizationGroupSearchOrderBy {
    return OrganizationGroupSearchOrderByFromJSONTyped(json, false);
}

export function OrganizationGroupSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupSearchOrderBy {
    return json as OrganizationGroupSearchOrderBy;
}

export function OrganizationGroupSearchOrderByToJSON(value?: OrganizationGroupSearchOrderBy | null): any {
    return value as any;
}

export function OrganizationGroupSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): OrganizationGroupSearchOrderBy {
    return value as OrganizationGroupSearchOrderBy;
}

